import { gql } from '@apollo/client';
import { SaleItemListFragment } from 'graphql/Deal/fragments/dealItemPicker/SaleItemListFragment';
/**
 * @const SaleItemsListQuery
 * @since 1.0.0
 */
export const SaleItemsListQuery = gql `
  query SaleItemsListQuery($input: SaleItemsInput) {
    saleItems(input: $input) {
      items {
        ...SaleItemListFragment
      }
      count
    }
  }

  ${SaleItemListFragment}
`;
